import type { CurrentUser, AttendanceStats, Notification } from '../models';

/**
 * 알림 생성 비즈니스 로직
 */
export class NotificationService {
  /**
   * 스마트 알림 생성
   * - 장시간 이용자 알림 (4시간 이상)
   * - 잔여 시간 부족 알림 (1시간 미만)
   */
  generateSmartNotifications(
    users: CurrentUser[],
    stats: AttendanceStats
  ): Notification[] {
    const notifications: Notification[] = [];
    const now = new Date();

    // 장시간 이용자 알림
    users.forEach((user) => {
      if (user.elapsed_time_minutes > 240) {
        // 4시간 이상
        const hours = Math.floor(user.elapsed_time_minutes / 60);
        const minutes = user.elapsed_time_minutes % 60;

        notifications.push({
          id: `long-session-${user.user_id}`,
          type: 'warning',
          title: '장시간 이용 알림',
          message: `${user.user_name}님이 ${hours}시간 ${minutes}분째 이용 중입니다.`,
          timestamp: now.toISOString(),
          acknowledged: false,
        });
      }
    });

    // 잔여 시간 부족 알림
    users.forEach((user) => {
      if (user.remaining_hours && user.remaining_hours < 1) {
        notifications.push({
          id: `low-time-${user.user_id}`,
          type: 'info',
          title: '잔여 시간 부족',
          message: `${user.user_name}님의 잔여 시간이 ${user.remaining_hours}시간 남았습니다.`,
          timestamp: now.toISOString(),
          acknowledged: false,
        });
      }
    });

    return notifications;
  }
}

// 싱글톤 인스턴스
export const notificationService = new NotificationService();
